/** Shared reload for approval membership commands: the host header first, then every board that quotes it. */
import { Injector } from '@angular/core';
import { ActivityEntityName } from '@jms/model';
import { EntityDataService } from '@workbuddy/services/entities';
import { ApprovalVisitsBoardParams } from '../visit.approval.detail.model';

export async function reloadApproval(injector: Injector, params: Pick<ApprovalVisitsBoardParams, 'changed'>): Promise<void> {

  // Header first: the next removal's expected revision comes from the reread approval.
  await params.changed?.();
  const data = injector.get(EntityDataService);
  await data.invalidateItems(ActivityEntityName.VisitApprovalVisit);
  await data.invalidateItems(ActivityEntityName.VisitApprovalRevision);
  await data.invalidateItems(ActivityEntityName.VisitApproval);
}
